module.exports = __webpack_public_path__ + "static/img/down-corner-ramp-8m-x-1m_256.8942031.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-corner-ramp-8m-x-1m_256.png
// module id = rI8F
// module chunks = 0